module.exports = __webpack_public_path__ + "media/Landing_Video2.83e827a7.mp4";